import { render } from "./program-detail.vue?vue&type=template&id=7bf59d0b"
import script from "./program-detail.vue?vue&type=script&lang=js"
export * from "./program-detail.vue?vue&type=script&lang=js"

import "./program-detail.vue?vue&type=style&index=0&id=7bf59d0b&lang=scss"
script.render = render

export default script